import httpClient from '@/http-client'

export const expenseItem = (Options = {}) => {
  return httpClient
      .post('/api/v1/reports/finances/yearly-expense-items', Options)
      .then(response => Promise.resolve(response.data))
      .catch(error => Promise.reject(error.response.data))
}

export const expenseItemExcel = data => {
  return httpClient
      .post('/api/v1/reports/finances/yearly-expense-items/excels', data, {
        responseType: 'arraybuffer'
      })
      .then(response => Promise.resolve(response))
      .catch(error => Promise.reject(error.response.data))
}

export const getExpenseItem = (Options = {}) => {
  return httpClient
      .get('/api/v1/reports/finances/expense-items', Options)
      .then(response => Promise.resolve(response.data))
      .catch(error => Promise.reject(error.response.data))
}

export default { expenseItem, getExpenseItem, expenseItemExcel }